import React from "react";
import { withTranslation } from "react-i18next";
import { Row, Col, Input } from "reactstrap";

const UserForm = ({ data }) => {
  return (
    <div className="d-flex flex-column mt-3 gap-4">
      <Row>
        <Col xs={12}>
          <div className="text-2xl whitespace-nowrap">อีเมล</div>
          <Input name="email" value={data?.email} type="email" placeholder="example@example.com" disabled={true} />
        </Col>
      </Row>
    </div>
  );
};

export default withTranslation()(UserForm);
